import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deletePlant } from '../actions/plants'
import { getBenefits } from '../actions/benefits'
import { FaTrash, FaPen } from 'react-icons/fa';


type PropsPlant = {
  plant?: any;
  id?: number;
  isForm?: boolean;
  setCurrentPlantId?: any;
  isSelected?: any;
  onClick?: (event: any) => void;
};

const Plant: React.FC<PropsPlant> = ({ isSelected, setCurrentPlantId, isForm = false, plant, onClick }) => {
  
  const dispatch = useDispatch();
  
  const history = useHistory();

  const imageUrl = plant.image ? plant.image : '';


  const plantBenefits = useSelector((state: any) => state.benefits.filter((benefit) => plant.benefits.includes(benefit._id)))
    
 

  useEffect(() => {
    dispatch(getBenefits())
  }, [dispatch])

  const redirectDetailPlant = () => {
    if (!isForm) {
      return history.push(`/detail/plants/${plant._id}`, plant)
    }
  }
  
  return (
    <div onClick={redirectDetailPlant} className="_flex _rounded-md _w-full _mb-sm" style={{ boxShadow: "0 3px 15px rgba(0, 0, 0, 0.2)" }}>
      <div className="_m-xs _bg-darkengreen _bg-no-repeat _bg-cover _bg-center _rounded-md" style={{ height: '80px', width: '80px', backgroundImage: `url(${imageUrl})` }}/>
      <section className="_my-xs _mr-xs _flex _flex-col _w-2/4">
        <div className="_flex _items-center">
          <h2>{plant.title}</h2>
          {plantBenefits && (
            <div className="_flex _items-center">
              {plantBenefits.length && (
                <div className="_ml-xs _bg-darkengreen _rounded-circle" style={{ height: '27px', width: '27px' }}>
                  <img src={plantBenefits[0].image} alt={plantBenefits[0].title} style={{filter: 'brightness(0) invert(1)'}} className="_bg-no-repeat _bg-cover _bg-center _p-xxs _w-full _h-full" />
                </div>
              )}
              { plantBenefits.length > 1 && (
                <div className="_-ml-xs _bg-white _border _border-darkengreen _rounded-circle _flex _justify-center  _text-darkengreen  _items-center" style={{ height: '27px', width: '27px' }}>
                  <p className="_text-sm"> +{plantBenefits.length - 1} </p>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="text-card">{plant.description}</div>
      </section>
      {isForm && (
        <div className="_m-xs _absolute _right-lg">
          <button className="_text-black hover:_bg-gray _rounded-card _p-xxs" type="button" onClick={() => setCurrentPlantId(plant._id)}>
            <FaPen />
          </button>
          <button className="_ml-xs _text-warning _p-xxs hover:_bg-gray _rounded-card" type="button" onClick={() => dispatch(deletePlant(plant._id))}>
            <FaTrash />
          </button>
        </div>
      )}
    </div>
  );
};

export default Plant;
